var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dropdown",
    { attrs: { disabled: _vm.noItems, label: _vm.label } },
    [
      _vm.showSearch
        ? _c("div", { staticClass: "dropdown-item" }, [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control has-icons-left" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchText,
                      expression: "searchText",
                    },
                  ],
                  staticClass: "input is-small",
                  attrs: { type: "search", placeholder: "Filter" },
                  domProps: { value: _vm.searchText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchText = $event.target.value
                    },
                  },
                }),
                _c("span", { staticClass: "icon is-left" }, [
                  _c("i", { staticClass: "fas fa-search" }),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.isFiltered
        ? _c(
            "div",
            { staticClass: "dropdown-item" },
            [
              _c(
                "b-checkbox",
                {
                  class: { "show-all-items": !_vm.selected.length },
                  attrs: { value: !_vm.selected.length },
                  nativeOn: {
                    change: function ($event) {
                      return function (e) {
                        return _vm.clear(e)
                      }.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("All " + _vm._s(_vm.type) + "s")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.filtered.length > 0
        ? _c(
            "div",
            _vm._l(_vm.filtered, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "dropdown-item" },
                [
                  _c(
                    "b-checkbox",
                    {
                      attrs: { "native-value": item.id },
                      on: { input: _vm.update },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(item.name) +
                          " (" +
                          _vm._s(item.users ? item.users.length : "0") +
                          ")"
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm.noMatch
        ? _c("div", { staticClass: "dropdown-item" }, [
            _c("p", [_vm._v("No match found for your filter")]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }